import { render } from "./Top10Card.vue?vue&type=template&id=3bf23975&scoped=true"
import script from "./Top10Card.vue?vue&type=script&lang=js"
export * from "./Top10Card.vue?vue&type=script&lang=js"

import "./Top10Card.vue?vue&type=style&index=0&id=3bf23975&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bf23975"

export default script